import { render, staticRenderFns } from "./modalPagoPayu.vue?vue&type=template&id=26255927"
import script from "./modalPagoPayu.vue?vue&type=script&lang=js"
export * from "./modalPagoPayu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports